var GrabToPan = require("exports?GrabToPan!./../vendors/grab_to_pan.js");
import config from "../../../common/config";

export default class GrabToPanComponent {
  g2p = null;

  constructor(DOMContainer) {
    this.DOMContainer = DOMContainer;
    this._init();
  }

  _init() {
    this.g2p = new GrabToPan({
      element: this.DOMContainer, // required
      moveThreshold: config.reader.moveThreshold,
    });
    this.g2p.activate();
  }

  enableGrabToPan() {
    this.g2p.activate();
  }

  disableGrabToPan() {
    this.g2p.deactivate();
  }

  on(...args) {
    this.g2p.on(...args);
  }

  off(...args) {
    this.g2p.off(...args);
  }
}



// WEBPACK FOOTER //
// ./src/web/reader/components/grabToPanComponent.js